import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { IconText } from "./IconText";

export type EmptyCardProps = {
  action?: ReactNode;
  icon: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
};

export const EmptyCard: FC<EmptyCardProps> = ({ action, icon, title, description, className }) => {
  return (
    <div className={twMerge("flex flex-col gap-4 rounded-lg bg-black-tint-97 p-4", className)}>
      {action ? (
        <div className="flex items-center justify-between gap-2">
          <IconText iconStart={icon} text={title} />
          {action}
        </div>
      ) : (
        <IconText iconStart={icon} text={title} />
      )}
      {description && <div className="body-s">{description}</div>}
    </div>
  );
};
